var CurrentUser = require("lib/account/CurrentUser");
var StudentAvatar = require("components/avatars/StudentAvatar");
var HouseAvatar = require("components/avatars/HouseAvatar");

require("org/student_lists/class_tree.scss");

class ClassTree extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		var currentStudent;
		if (CurrentUser.isStudent()) {
			currentStudent = _.find(props.students, function(student) {
				return CurrentUser.hasID(student.id);
			});
			currentStudent = currentStudent || props.students[0];
		}
		this.state = { currentStudent: currentStudent};
	}

	render () {
		// Function to flatten owl array
		const flatten = arr => arr.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
		
		var students = $wr.sortByName(this.props.students, "flexName"); 
		// var studentGroups = $wr.fetchSlicedItems(students, 6);
		// Split owls and houses on branches
		var studentGroups = [[]]
		var available_spots = 6
		var array_index = 0
		students.forEach(function(s,i) {
			if (s.perks && s.perks.houses){
				if (available_spots > 1) {
					available_spots -= 2
				} else {
					available_spots = 4
					studentGroups.push([])
					array_index += 1
				}
			} else {
				available_spots -= 1
			}
			studentGroups[array_index].push(s)
			if (available_spots <= 0 && i < students.length - 1) {
				studentGroups.push([])
				array_index += 1
				available_spots = 6
			}
		})
		var branch1 = (
			<img src={ require("trees/branch-green.png") } className="treeBranchImg" />
		)
		var branch2 = (
			<img src={ require("trees/branch-gold.png") } className="treeBranchImg" />
		)
		var currentBranch = true;
		var studentsRowDisplay = studentGroups.map(function(studentGroup,j){
			if (currentBranch) {
				var displayBranch = branch1;
			} else {
				var displayBranch = branch2;
			}
			currentBranch = !currentBranch;
			//Get Owls and houses
			var item_index = 0
			var	owls = flatten(studentGroup.map(function(student,i){
		
				var ret = []
				ret.push(<div key={ item_index } ref={"owl_"+student.id} className="avatarAndName">
							<div className="studentName">
								<div>
									{ $wr.fetchTitle(student, "onlyFirstName") }
								</div>
								<span className='owlLevel'>
									{ `Owl Level ${student.tier + 1}` }
								</span>
							</div> 	
							<StudentAvatar student={ student } maxWidth={ 115 } disableSound={true}/>	
						</div>)
				item_index += 1
				// Add house second
				if (student.perks && student.perks.houses) {
					if (CurrentUser.isAdmin() || CurrentUser.hasID(student.id)) {
						var houseAvatar = (
							<div key={ item_index } className="avatarAndName avatarWithHouse" >
								<HouseAvatar maxWidth={ 90 } student={ student }/>
							</div>
						)
					} else {
						var houseAvatar = (
							<div key={ item_index } className="avatarAndName avatarWithHouse">
								<HouseAvatar maxWidth={ 90 } student={ student } currentStudent={ this.state.currentStudent } />
							</div>
						)
					}
					item_index += 1	
				}
				ret.push(houseAvatar)
				return ret;

			}.bind(this)));
			var key = _.pluck(studentGroup, "id").join("-");
			return (
				<div className="studentRows" key={ key } >
					<div className="owlLine">{ owls }</div>
					{ displayBranch }
				</div>
			)
		}.bind(this));

		return (
			<div className="classTree">
				<div className="treeTopContainer">
					<img src={ require("trees/tree-top.png") } className="" />
				</div>
				<div className="studentsContainer classTreeArea">
					<div className="studentRowsSection">
						{ studentsRowDisplay }
					</div>
				</div>
				<div className="treeRootsContainer">
					<img src={ require("trees/roots.png") } className="treeRoots" />
				</div>
			</div>	
		);
	}

	adjustAvatars() {
		this.props.students.forEach(function(s,i){
			var height = $(this.refs["owl_"+s.id]).find(".studentName").css('height')
			if (height) {
				var h = parseInt(height.replace('px',''))
				// var h = parseInt($("#owl_"+s.username).find(".studentName").css('height').replace('px',''))
				if (h > 25) {
					 $(this.refs["owl_"+s.id]).addClass('adjustedAvatarAndName')
				}
			}
		}.bind(this))
	}

	componentDidMount() {
		this.adjustAvatars();
	}
};

ClassTree.propTypes = StrictPropTypes({
	students: PropTypes.array.isRequired
});

module.exports = ClassTree;



// WEBPACK FOOTER //
// ./modules/components/org/student_lists/ClassTree.js